<app-cart-nav></app-cart-nav>
@if (!dataSource) {
    <div>
        <app-loading></app-loading>
    </div>
}
<br/>
@if (dataSource) {
    <div>
        <div style="overflow-x: auto;">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef> {{ 'general.product' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <app-logo [overrideDefaultClass]="imgStyle"></app-logo> -->
                        <img class="fade-in product-img" [ngClass]="{inverted: theme == '0'}" onerror="'assets/images/DSLogo.png'" src="{{this.productImages}}/thumbs/{{element.name}}.png"/>
                    </td>
                </ng-container>
                <ng-container matColumnDef="description">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.description' | transloco }}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.description }}</td>
                </ng-container>
                <ng-container class="qty" matColumnDef="qty">
                    <th mat-header-cell *matHeaderCellDef>{{ 'general.quantity' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">
                        <mat-form-field style="width:60px !important; padding-right: 20px">
                            <input [disabled]="chargeMode == true" autocomplete="off" (change)="onChangeCartQty(element, $event.target['value'])" matInput type="number" value="{{element.product_count}}">
                        </mat-form-field>
                    </td>
                </ng-container>
                <ng-container matColumnDef="price">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.price' | transloco }}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.product_price | StringJSV2Pipe:stringJSPipeArgs }}</td>
                </ng-container>
                <ng-container matColumnDef="total">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.total' | transloco }}</th>
                    <td mat-cell *matCellDef="let element"> {{ $any(element.product_price * element.product_count) | StringJSV2Pipe:stringJSPipeArgs }}</td>
                </ng-container>
                <ng-container matColumnDef="notes">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.notes' | transloco }}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.item_notes }}</td>
                </ng-container>
                <ng-container matColumnDef="remove">
                    <th mat-header-cell *matHeaderCellDef>{{ 'general.remove' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">
                            <button [disabled]="chargeMode == true" (click)="onRemoveCartNav(element)" mat-icon-button style="opacity: 0.7;">
                                <mat-icon>remove_shopping_cart</mat-icon>
                            </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row (click)="onSelectedRow(row)" class="table-row" tabindex="1" *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <br/>
        <div style="padding: 10px">
            <div class="wrap">
                <div [style.grid-area]="'l1'">{{ 'general.subtotal' | transloco }}</div>
                <div [style.grid-area]="'l2'">{{ $any(subTotal) | StringJSV2Pipe:stringJSPipeArgs }}</div>
                <div [style.grid-area]="'l3'">{{ 'general.shipTo' | transloco }}</div>
                <div [style.grid-area]="'l4'" style="position: relative; top: -15px">
                    <mat-form-field>
                        <!--                    <mat-label>select scene item</mat-label>-->
                        <mat-select (selectionChange)="onSelectedShipTo($event)" [(value)]="selectedShipTo">
                            @for (item of usSates; track item) {
                                <mat-option [value]="item.name">{{ item.value }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div [style.grid-area]="'l5'">{{ 'general.delivery' | transloco }}</div>
                <div [style.grid-area]="'l6'" style="position: relative; top: -15px">
                    <mat-form-field>
                        <!--                    <mat-label>select scene item</mat-label>-->
                        <mat-select disabled (selectionChange)="onSelectedBy($event)" [(value)]="selectedShipBy">
                            @for (item of ['UPS', 'USPS']; track item) {
                                <mat-option [value]="item">{{ item }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div [style.grid-area]="'l7'">{{ 'general.tax' | transloco }}</div>
                <div [style.grid-area]="'l8'">{{ $any(taxTotal) | StringJSV2Pipe:stringJSPipeArgs }}</div>
                <div [style.grid-area]="'l9'">{{ 'general.shipping' | transloco }}</div>
                <div [style.grid-area]="'l10'">{{ $any(shippingTotal) | StringJSV2Pipe:stringJSPipeArgs }}</div>
                <div [style.grid-area]="'l11'">{{ 'general.orderTotal' | transloco }}</div>
                <div [style.grid-area]="'l12'">{{ $any(orderTotal) | StringJSV2Pipe:stringJSPipeArgs }}</div>
            </div>
        </div>
        <div fxLayout="row-reverse">
            <button (click)="onCheckout()" class="subButton" color="warn" mat-raised-button type="submit" [disabled]="disabledCheckout">
                <mat-icon>exit_to_app</mat-icon>
                {{ 'general.checkout' | transloco }}
            </button>
        </div>
        <!--    <div class="pull-right" style="opacity: 0.2; word-break: break-word;" *ngIf="devMode">-->
        <!--        <label>cart: {{cartCreate.orderId}}</label>-->
        <!--        <br/>-->
        <!--        <mat-label>created: {{cartCreate.time}}</mat-label>-->
        <!--    </div>-->
    </div>
}

